<template>
  <span v-text="text" />
</template>

<script>
import { IntervalMailSendingStatus } from '@/models/Report/IntervalReport'

export default {
  name: 'IntervalReportListClosingDate',
  props: {
    value: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
  },
  computed: {
    text() {
      return this.status === IntervalMailSendingStatus.ACTIVE ? this.value : '-'
    },
  },
}
</script>
